import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import { StateService } from 'src/app/services/states.service';
import { CustomerService } from 'src/app/services/customer.service';
import { DialogQuestionMessage } from '../../views/dialogs-question/dialog-question-message.component';

@Injectable({
    providedIn: 'root',
})
export class deleteAccountService {
    user;
    
    constructor(
        private dialog: MatDialog,
        private customerService: CustomerService,
        private cookies: CookieService,
        private stateService: StateService,
    ) {}

    openDeleteDialog() {
        let dialog = this.openQuestionDialog(
            "Suppression de compte", 
            "Vous avez demandé de supprimer votre compte et tous les dossiers attachés à ce dernier." 
            + "\n" + "Toutes les données seront définitivement supprimées.", true);
        this.loadCurrentUser();
        this.afterClosingDeleteDialog(dialog);
    }

    loadCurrentUser() {
        this.stateService.user.subscribe((user) => {
            this.user = user;
        })
    }

    afterClosingDeleteDialog(dialog) {
        dialog.afterClosed().subscribe(res => {
            if (res && res.positive) {
                if (this.user != null) {
                    this.customerService.deleteAccount(this.user.ID).subscribe((response) => {
                        if (response.result.success) {
                            this.messageAccountGotDeleted();
                            this.redirectAfterAccountDeleted();
                        }
                    });
                }
            }
        })
    }

    openQuestionDialog(title, body, danger = false, hideButtons = false) {
        return this.dialog.open(DialogQuestionMessage, {
            disableClose: true,
            width: '100%',
            panelClass:'question-dialog',
            data : {
                title : title,
                body : body,
                danger : danger,
                hideButtons : hideButtons,
            }
        });
    }

    messageAccountGotDeleted() {
        this.openQuestionDialog(
            "Compte Supprimé", 
            "Votre compte à bien été supprimé, vous allez être redirigé à la page d'accueil.", 
            false, 
            true
        )
    }

    redirectAfterAccountDeleted() {
        this.cookies.set("Tokenauth", "");
        setTimeout(() => {
            location.replace("");
        }, 4000);
    }
}